import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';
import { translate } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'inline-block',
        maxHeight: '100vh',
        overflow: 'auto'
    },
}));

function AddCardStorageModal(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);

    let history = useHistory();

    const close = () => {
        setOpen(false);
        props.onClose();
    }
    
    useEffect(() => {
        setOpen(props.open)
    }, [props.open])

    const triggerFunc = (val) => {
        if (val) {
            props.triggerFunc(val);
        } else {
            close()
            history.push("/")
        }
    }

    return (
        <div>
            <Modal
                open={open}
                onClose={close}
                style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                classes={classes.modal}
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description">
                <Fade in={open}>
                    <div className={classes.paper}>
                        <div className="modal-sms-service">
                            <div className="modal-sms-service-head">
                                <h2>{props.title}</h2>
                            </div>
                            <div className="modal-sms-service-body">
                                <p style={{ textAlign: 'center' }}>{props.body}</p>
                            </div>
                            <div className="modal-sms-service-buttons">
                                <button className="modal-sms-service-button-yes" onClick={() => triggerFunc(true)}>{props.t('save')}</button>
                                <button className="modal-sms-service-button-no" onClick={() => triggerFunc(false)}>{props.t('cancel')}</button>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    );
}

export default translate("translation")(AddCardStorageModal);